export interface PublicGalleryPhoto {
  id: string;
  title: string;
  image_url: string;
  description: string | null;
  category: string | null;
  category_division: string;
}

interface GalleryRecord {
  id: string | number;
  title: string;
  image_url?: string;
  image?: string;
  description?: string | null;
  category_tag?: string | null;
  gallery_division?: string | null;
  is_published: boolean;
}

const baseUrl = import.meta.env.DEV
  ? "/jambushrusti-api"
  : (
      import.meta.env.VITE_API_BASE_URL ||
      "https://api.jambushusti.universal-software.in/api"
    ).replace(/\/$/, "");
const endpoint = `${baseUrl}/jambushrusti/cms/media-gallery/`;

export async function fetchPublicGallery(
  signal?: AbortSignal
): Promise<PublicGalleryPhoto[]> {
  const photos: PublicGalleryPhoto[] = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const response = await fetch(`${endpoint}?page=${page}`, {
      signal,
      headers: {
        "X-Tenant-ID":
          import.meta.env.VITE_X_TENANTID ||
          "6cf833d7-bf6f-4688-9136-5674d8053b85",
      },
    });
    if (!response.ok) {
      throw new Error("Unable to load gallery photos. Please try again.");
    }
    const payload = await response.json();
    const data = payload.data ?? payload;
    const rows: GalleryRecord[] = Array.isArray(data) ? data : data.results;
    if (!Array.isArray(rows)) {
      throw new Error("The gallery response could not be read.");
    }

    for (const photo of rows) {
      const imageUrl = photo.image || photo.image_url;
      if (photo.is_published === true && imageUrl) {
        photos.push({
          id: String(photo.id),
          title: photo.title || "Photo",
          image_url: imageUrl,
          description: photo.description || null,
          category: photo.category_tag || null,
          category_division: photo.gallery_division || "gurudev",
        });
      }
    }
    hasNext = Boolean(data.links?.next ?? data.next);
    page += 1;
  }
  return photos;
}
